import './site-header.scss';

import AjaxLoad from '../../utilities/js/ajax-load';

class SiteHeader {
    constructor (element, options) {
        const settings = {
            resizeHandler: null,
            scrollHandler: null
        };

        this.settings = Object.assign({}, settings, options);
        this.$siteHeader = element;
        this.activeSide = document.querySelector('[data-rotate]');
        this.switches = document.querySelectorAll('[data-sub-switch]');
        this.rotate = document.querySelectorAll('[data-header-rotate]');
        this.headerBar = document.querySelector('.site-header__bar');
        this.searchForm = document.querySelector('[data-header-search="form"]');
        this.backButtons = document.querySelectorAll('[data-header-back]');
        this.searchFlip = document.querySelector('[data-header-search="flip"]');
        this.variantImages = document.querySelectorAll('[data-kitchen-variante-image]');
        this.$headerStudioRemovers = document.querySelectorAll('[data-header-studio-remove]');
        this.oldBrowser = null;
        this.scrollRange = 0;
        this.pageOffset = window.pageYOffset;
        this.$secondaryNav = document.querySelector('.site-subheader');

        if (document.querySelector('html').classList.contains('ie10') || document.querySelector('html').classList.contains('ie11')) {
            this.oldBrowser = true;
        } else {
            this.oldBrowser = false;
        }

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.settings.scrollHandler) {
            this.settings.scrollHandler.customFunctions.push(() => {
                const currentScroll = this.settings.scrollHandler.getScrollInfo();
                this.checkSecondaryNav(currentScroll.position, currentScroll.direction, currentScroll.lastPosition);
            });
        }

        for (let SwitchEventIndex = 0; SwitchEventIndex < this.switches.length; SwitchEventIndex++) {
            this.checkAnchors(SwitchEventIndex);
        }

        // Rotate to the specified Side
        this.rotate.forEach(el => {
            const elDirection = el.getAttribute('data-header-rotate');
            el.addEventListener('click', e => {
                if (window.innerWidth >= 768) {
                    this.rotateTo(elDirection);
                }
                e.preventDefault();
            });
        });

        // Back Buttons Events
        this.backButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.rotateTo('front');
            });
        });

        window.addEventListener('orientationchange', () => {
            const $mobileNav = this.$siteHeader.querySelector('[data-sub-switch="mobile-nav"]');
            const $headerSearchDesktopInput = document.querySelector('[data-header-search="input"].navigation-search__input');
            const $headerSearchMobileInput = document.querySelector('[data-header-search="input"].navigation-search__mobile-input');
            const isMobileFocused = document.activeElement === $headerSearchMobileInput;
            const isDesktopFocused = document.activeElement === $headerSearchDesktopInput;

            if ($mobileNav.classList.contains('switch--active')) {
                if (isMobileFocused) {
                    const $headerRotateTop = document.querySelector('[data-header-rotate="top"]');
                    $headerSearchMobileInput.blur();
                    $mobileNav.click();

                    setTimeout(() => {
                        $headerRotateTop.click();
                        $headerSearchDesktopInput.value = $headerSearchMobileInput.value;

                        setTimeout(() => {
                            $headerSearchDesktopInput.focus();
                        }, 1000);
                    }, 500);
                } else {
                    $mobileNav.click();
                }
            } else {
                if (isDesktopFocused) {
                    const $headerBack = document.querySelector('[data-header-back]');

                    if ($headerBack) {
                        $headerBack.click();
                        $headerSearchMobileInput.value = $headerSearchDesktopInput.value;

                        setTimeout(() => {
                            $mobileNav.click();
                            setTimeout(() => {
                                $headerSearchMobileInput.focus();
                            }, 750);
                        }, 750);
                    }
                }
            }
        });

        /*******************************************/
        /* Kitchen Variant Image Events ************/
        const variantImageEvent = (index) => {
            this.variantImages[index].addEventListener('click', (e) => {
                const loader = '<span class="loading loading--show"><b class="loader"><i>loading...</i></b></span>';

                e.preventDefault();
                document.querySelector('[data-panorama]').click();
                if (!this.variantImages[index].parentNode.classList.contains('navigation-sub-switch__image')) {
                    // this.variantImages[index].after($(loader)[0]);
                    this.variantImages[index].insertAdjacentElement('afterend', loader);
                }
            });
        };

        if (this.variantImages.length > 0) {
            for (let variantIndex = 0; variantIndex < this.variantImages.length; variantIndex++) {
                variantImageEvent(variantIndex);
            }
        }

        if (this.$headerStudioRemovers) {
            this.$headerStudioRemovers.forEach(hsr => {
                hsr.addEventListener('click', e => {
                    const headerStudioRemoverUri = hsr.dataset.removeRoute;
                    const $target = hsr.parentNode.querySelector('.navigation-main__location__studio');
                    const $original = hsr.parentNode.querySelector('.navigation-main__location');

                    // $.get($(e.target).data('remove-route'));

                    // eslint-disable-next-line no-new
                    new AjaxLoad(headerStudioRemoverUri, {
                        requestMethod: 'get',
                        onSuccess: () => {
                            console.log('remove');
                        }
                    });

                    $target.classList.add('is--hidden');
                    $original.classList.remove('is--hidden');

                    setTimeout(() => {
                        $target.parentNode.removeChild($target);
                        e.target.parentNode.removeChild(e.target);
                    }, 400);
                });
            });
        } else {
            console.log('no this.$headerStudioRemovers');
        }
    }

    toggleSwitchEvent (index) {
        this.switches[index].addEventListener('click', () => {
            const $target = document.querySelector('[data-sub-target="' + this.switches[index].getAttribute('data-sub-switch') + '"]');

            $target.addEventListener('click', (e) => {
                if (e.target.tagName.toLowerCase() === 'a') {
                    $target.style.height = '';
                    this.switches[index].classList.remove('switch--active');
                    $target.classList.remove('target--open');
                } else {
                    if (e.target.tagName.toLowerCase() !== 'button') {
                        e.preventDefault();
                    }
                }
            });

            if ($target.classList.contains('target--open')) {
                this.toggleSwitch('close', $target, index);
            } else {
                this.toggleSwitch('open', $target, index);
            }
        });
    }

    checkAnchors (index) {
        const $anchorTarget = document.querySelector('[data-sub-target="' + this.switches[index].getAttribute('data-sub-switch') + '"]');
        let $anchors;

        if ($anchorTarget) {
            $anchors = $anchorTarget.querySelectorAll('[data-scroller]');

            if ($anchors.length > 0) {
                for (let anchorIndex = 0; anchorIndex < $anchors.length; anchorIndex++) {
                    const $anchor = document.querySelector($anchors[anchorIndex].getAttribute('href'));

                    if (!$anchor) {
                        $anchors[anchorIndex].parentNode.remove();
                    }
                }
            }
        }

        this.toggleSwitchEvent(index);
    }

    toggleSwitch (action, $target, index) {
        if (typeof $target !== 'undefined') {
            if (typeof index !== 'undefined') {
                if (action === 'close') {
                    if ($target.getAttribute('data-sub-target') === 'mobile-nav' || $target.getAttribute('data-sub-target') === 'mobile-location') {
                        this.$siteHeader.style.transform = '';
                    }

                    $target.style.height = '';
                    this.switches[index].classList.remove('switch--active');
                    $target.classList.remove('target--open');
                    this.$siteHeader.classList.remove('is--open');
                } else if (action === 'open') {
                    if ($target.getAttribute('data-sub-target') === 'mobile-nav' || $target.getAttribute('data-sub-target') === 'mobile-location') {
                        let $targetOther;
                        if ($target.getAttribute('data-sub-target') === 'mobile-nav') {
                            $targetOther = document.querySelector('[data-sub-target="mobile-location"]');
                            if ($targetOther) {
                                $targetOther.style.height = '';
                                $targetOther.classList.remove('target--open');
                                document.querySelector('[data-sub-switch="mobile-location"]').classList.remove('switch--active');
                            }
                        }
                        if ($target.getAttribute('data-sub-target') === 'mobile-location') {
                            $targetOther = document.querySelector('[data-sub-target="mobile-nav"]');
                            if ($targetOther) {
                                $targetOther.style.height = '';
                                $targetOther.classList.remove('target--open');
                                document.querySelector('[data-sub-switch="mobile-nav"]').classList.remove('switch--active');
                            }
                        }
                        if ($target.scrollHeight >= (window.innerHeight - 120)) {
                            this.$siteHeader.style.transform = 'translateY(-' + (window.innerHeight - 120) + 'px)';
                        } else {
                            this.$siteHeader.style.transform = 'translateY(-' + $target.scrollHeight + 'px)';
                        }
                    }

                    this.switches[index].classList.add('switch--active');
                    if ($target.scrollHeight >= (window.innerHeight - 60)) {
                        $target.style.height = (window.innerHeight - 60) + 'px';
                    } else {
                        $target.style.height = $target.scrollHeight + 'px';
                    }
                    $target.classList.add('target--open');

                    this.$siteHeader.classList.add('is--open');
                }
            }
        }
    }

    rotateTo (position) {
        this.activeSide = position;

        for (let i = 0; i < this.switches.length; i++) {
            if (this.switches[i].classList.contains('switch--active')) {
                const $target = this.$siteHeader.querySelector('[data-sub-target="' + this.switches[i].getAttribute('data-sub-switch') + '"]');
                this.toggleSwitch('close', $target, i);
            }
        }
        this.headerBar.setAttribute('data-rotate', position);
    }

    checkSecondaryNav (scrollPos, direction, lastScrollPos) {
        if (this.$secondaryNav) {
            if (direction === 'down') {
                this.scrollRange += scrollPos - lastScrollPos;
                if (this.scrollRange >= 300) {
                    this.headerBar.setAttribute('data-rotate', 'bottom');
                    this.$secondaryNav.classList.add('is--visible');
                    this.scrollRange = 0;
                }
            }

            if (direction === 'up') {
                this.scrollRange += lastScrollPos - scrollPos;
                if (this.scrollRange >= 300) {
                    this.headerBar.setAttribute('data-rotate', 'front');
                    this.$secondaryNav.classList.remove('is--visible');

                    if (this.$secondaryNav.querySelector('.navigation-sub-switch')) {
                        if (this.$secondaryNav.querySelector('.navigation-sub-switch').classList.contains('switch--active')) {
                            this.$secondaryNav.querySelector('.navigation-sub-switch__wrapper').style.height = '';
                            this.$secondaryNav.querySelector('.navigation-sub-switch').classList.remove('switch--active');
                            this.$secondaryNav.querySelector('.navigation-sub-switch__wrapper').classList.remove('target--open');
                        }
                    }
                    this.scrollRange = 0;
                }
            }

            if (scrollPos < 300) {
                this.headerBar.setAttribute('data-rotate', 'front');
                this.$secondaryNav.classList.remove('is--visible');

                if (this.$secondaryNav.querySelector('.navigation-sub-switch')) {
                    if (this.$secondaryNav.querySelector('.navigation-sub-switch').classList.contains('switch--active')) {
                        this.$secondaryNav.querySelector('.navigation-sub-switch__wrapper').style.height = '';
                        this.$secondaryNav.querySelector('.navigation-sub-switch').classList.remove('switch--active');
                        this.$secondaryNav.querySelector('.navigation-sub-switch__wrapper').classList.remove('target--open');
                    }
                }
            }
        }
    }
}

export { SiteHeader };
